import { Destination } from '../contexts/@prequel/type';

/**
 * Extract vendor-specific destination details for display in the UI
 * Based on the destination configuration structure from the API response
 *
 * @param destination - The destination object from the API
 * @param t - Translation function for labels
 * @returns Array of detail strings to display
 */
export const getDestinationDetails = (
  destination: Destination,
  t: (key: string) => string,
): string[] => {
  const vendorConfig = (destination as Record<string, any>)[destination.vendor] || {};
  const details: string[] = [];

  switch (destination.vendor) {
    case 'bigquery':
      if (vendorConfig.bucket_gcs?.bucket_name) {
        details.push(
          `${t('transferHistory.destinationDetails.bucket')}: ${vendorConfig.bucket_gcs.bucket_name}`,
        );
      }
      break;

    case 'databricks':
      if (vendorConfig.catalog) {
        details.push(
          `${t('transferHistory.destinationDetails.database')}: ${vendorConfig.catalog}`,
        );
      }
      if (vendorConfig.schema) {
        details.push(`${t('transferHistory.destinationDetails.schema')}: ${vendorConfig.schema}`);
      }
      break;

    case 'gcs':
      if (vendorConfig.folder) {
        details.push(`${t('transferHistory.destinationDetails.folder')}: ${vendorConfig.folder}`);
      }
      if (vendorConfig.bucket_name) {
        details.push(
          `${t('transferHistory.destinationDetails.bucket')}: ${vendorConfig.bucket_name}`,
        );
      }
      break;

    case 'redshift':
      if (vendorConfig.database) {
        details.push(
          `${t('transferHistory.destinationDetails.database')}: ${vendorConfig.database}`,
        );
      }
      if (vendorConfig.schema) {
        details.push(`${t('transferHistory.destinationDetails.schema')}: ${vendorConfig.schema}`);
      }
      break;

    case 's3':
      if (vendorConfig.bucket_name) {
        details.push(
          `${t('transferHistory.destinationDetails.bucket')}: ${vendorConfig.bucket_name}`,
        );
      }
      break;

    case 'sftp':
      if (vendorConfig.folder) {
        details.push(`${t('transferHistory.destinationDetails.folder')}: ${vendorConfig.folder}`);
      }
      break;

    case 'snowflake':
      if (vendorConfig.database) {
        details.push(
          `${t('transferHistory.destinationDetails.database')}: ${vendorConfig.database}`,
        );
      }
      if (vendorConfig.schema) {
        details.push(`${t('transferHistory.destinationDetails.schema')}: ${vendorConfig.schema}`);
      }
      break;

    default:
      // Fallback for unknown vendors
      if (vendorConfig.bucket_name) {
        details.push(
          `${t('transferHistory.destinationDetails.bucket')}: ${vendorConfig.bucket_name}`,
        );
      }
      if (vendorConfig.folder) {
        details.push(`${t('transferHistory.destinationDetails.folder')}: ${vendorConfig.folder}`);
      }
      if (vendorConfig.database) {
        details.push(
          `${t('transferHistory.destinationDetails.database')}: ${vendorConfig.database}`,
        );
      }
      if (vendorConfig.schema) {
        details.push(`${t('transferHistory.destinationDetails.schema')}: ${vendorConfig.schema}`);
      }
      break;
  }

  return details;
};
